module.exports = __webpack_public_path__ + "img/speaker3.b24291ec.png";